module.exports = __webpack_public_path__ + "bf1490d216a3579799d5b0c1cfc8071e.svg";